document.addEventListener('DOMContentLoaded', function () {
  const blocSettings = document.querySelector('.bloc-settings');
  if (blocSettings) {
    const nightModeButton = document.createElement('button');
    nightModeButton.classList.add('night-mode-button');
    nightModeButton.style.width = '100%';
    nightModeButton.style.height = '100%';
    nightModeButton.style.margin = '0';
    nightModeButton.textContent = 'Modifier le thème';
    blocSettings.appendChild(nightModeButton);

    nightModeButton.addEventListener('click', function () {
      toggleNightMode();
    });
  }

  function toggleNightMode() {
    document.body.classList.toggle('night-mode');
    localStorage.setItem('night-mode', document.body.classList.contains('night-mode'));
    toggleLogo();
  }

  if (localStorage.getItem('night-mode') === 'true') {
    document.body.classList.add('night-mode');
    toggleLogo();
  }

  function toggleLogo() {
    const lightLogo = document.getElementById('light-logo');
    const darkLogo = document.getElementById('dark-logo');
  
    if (lightLogo && darkLogo) {
      if (document.body.classList.contains('night-mode')) {
        lightLogo.style.display = 'none';
        darkLogo.style.display = 'block';
      } else {
        lightLogo.style.display = 'block';
        darkLogo.style.display = 'none';
      }
    }
  }
});

  document.addEventListener('DOMContentLoaded', function () {
  // ...
  if (localStorage.getItem('night-mode') === 'true') {
    document.body.classList.add('night-mode');
    toggleLogo(); // Appeler la fonction toggleLogo() lors de l'initialisation
  }
});
